export class Sectors {
  static sectorMap = {
    Healthcare: { long: "Здравоохранение", short: "Здрав." },
    Technology: { long: "Технологии", short: "Технол." },
    Materials: { long: "Сырьевая промышленность", short: "Сырьев." },
    "Consumer Goods": { long: "Потребительские товары", short: "Потреб." },
    Utilities: { long: "Коммунальный сектор", short: "Коммун." },
    Services: { long: "Сфера услуг", short: "Услуги" },
    Financial: { long: "Финансовый сектор", short: "Финанс." },
    "Industrial Goods": { long: "Промышленность", short: "Пром." }
  };

  /**
   * @param { string } sector - Индентификатор
   * @param { Object } params - Параметры
   * @param { "long" | "short" } params.type - Написание
   */
  static getLabel(sector, { type = "long" } = {}) {
    const noSectors = type === "short" ? "Неизв." : "Неизвестный";

    return Sectors.sectorMap[sector]?.[type] ?? noSectors;
  }
}
